export const messages = {
  en: {
    dengkeMachine: {
      list: {
        title: 'Dengke Access Control Devices'
      },
      tab: {
        all: 'All',
        unit: 'Unit Devices',
        perimeter: 'Perimeter Devices'
      },
      search: {
        title: 'Search Conditions',
        buildingNum: 'Please enter building number',
        unitNum: 'Please enter unit number',
        machineAlias: 'Please enter device alias',
        machineCode: 'Please enter device code',
        machineIp: 'Please enter device IP',
        onlineStatus: 'Please select online status'
      },
      table: {
        machineAlias: 'Device Alias',
        machineCode: 'Device Code',
        productName: 'Product Name',
        applyType: 'Application Type',
        location: 'Location',
        buildingNum: 'Building',
        unitNum: 'Unit',
        machineIp: 'IP Address',
        onlineStatus: 'Online Status',
        online: 'Online',
        offline: 'Offline',
        operation: 'Operation'
      },
      stats: {
        total: 'Total Devices',
        unit: 'Unit Devices',
        perimeter: 'Perimeter Devices',
        online: 'Online Devices'
      },
      detail: {
        title: 'Device Detail',
        machineId: 'Device ID',
        machineAlias: 'Device Alias',
        machineCode: 'Device Code',
        did: 'Device DID',
        communityId: 'Community ID',
        subsystem: 'Subsystem',
        productName: 'Product Name',
        productType: 'Product Type',
        applyType: 'Application Type',
        locationDetail: 'Location Detail',
        direction: 'Direction',
        machineIp: 'IP Address',
        factory: 'Manufacturer',
        onlineStatus: 'Online Status',
        serialNumber: 'Serial Number',
        macAddress: 'MAC Address',
        hardwareVersion: 'Hardware Version',
        mainVersion: 'Main Version',
        faceVersion: 'Face Version',
        fingerVersion: 'Finger Version',
        buildingNum: 'Building',
        unitNum: 'Unit',
        icCardNum: 'IC Card Count',
        faceNum: 'Face Count',
        fingerNum: 'Finger Count',
        bluetoothNum: 'Bluetooth Count',
        qrcodeNum: 'QR Code Count',
        createTime: 'Create Time'
      },
      message: {
        fetchError: 'Failed to fetch Dengke device list'
      }
    }
  },
  zh: {
    dengkeMachine: {
      list: {
        title: '登科门禁设备'
      },
      tab: {
        all: '全部设备',
        unit: '单元设备',
        perimeter: '围墙机'
      },
      search: {
        title: '查询条件',
        buildingNum: '请输入楼栋编号',
        unitNum: '请输入单元编号',
        machineAlias: '请输入设备别名',
        machineCode: '请输入设备编码',
        machineIp: '请输入设备IP',
        onlineStatus: '请选择在线状态'
      },
      table: {
        machineAlias: '设备别名',
        machineCode: '设备编码',
        productName: '产品名称',
        applyType: '应用类型',
        location: '所在位置',
        buildingNum: '楼栋',
        unitNum: '单元',
        machineIp: 'IP地址',
        onlineStatus: '在线状态',
        online: '在线',
        offline: '离线',
        operation: '操作'
      },
      stats: {
        total: '设备总数',
        unit: '单元设备',
        perimeter: '围墙机',
        online: '在线设备'
      },
      detail: {
        title: '设备详情',
        machineId: '设备ID',
        machineAlias: '设备别名',
        machineCode: '设备编码',
        did: '设备唯一标识',
        communityId: '小区ID',
        subsystem: '所属系统',
        productName: '产品名称',
        productType: '产品类型',
        applyType: '应用类型',
        locationDetail: '所在地址',
        direction: '进出方向',
        machineIp: 'IP地址',
        factory: '厂商',
        onlineStatus: '在线状态',
        serialNumber: '序列号',
        macAddress: 'MAC地址',
        hardwareVersion: '硬件版本',
        mainVersion: '主程序版本',
        faceVersion: '人脸版本',
        fingerVersion: '指纹版本',
        buildingNum: '楼栋',
        unitNum: '单元',
        icCardNum: 'IC卡数量',
        faceNum: '人脸数量',
        fingerNum: '指纹数量',
        bluetoothNum: '蓝牙数量',
        qrcodeNum: '二维码数量',
        createTime: '创建时间'
      },
      message: {
        fetchError: '获取登科设备列表失败'
      }
    }
  }
}
